export default "__VITE_ASSET__DL$Gdesk__"